import { Filter } from 'src/utils/composeFilter.ts';
import { OperationMode } from 'src/modules/common/constants.ts';

export const isOCCOSelected = (filter: Filter): boolean => (filter[OperationMode] || []).includes('Open/close');
